<template>
  <v-row>
    <v-col>
      <Table
        :items="items"
        :headers="headers"
        :openDialog="openDialog"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
      />
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        persistent
        @keydown.esc="reset(false)"
      >
        <Form
          :key="modeTables"
          :itemsSelect="selectsData"
          :disableSelect="disableSelectModo()"
          @save="save"
          @cancel="reset"
          :maxWidth="'580px'"
          :show="true"
          :mode="modeTables"
          :showDate="true"
          :showDateFrom="true"
          :showDateTo="true"
          :showCheck="true"
          :multiple="true"
        />
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[1]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import Table from "@/components/Complement/TableWithSearch";
import Form from "@/components/Complement/Form";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import date from "@/store/common/date";
import operators from "../../../../store/operadores/operators";
import moment from "moment";

export default {
  components: {
    Table,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      valid: true,
      error: false,
      alertValidate: "",
      title: this.$tc("operators.audit"),
      titleDelete: this.$tc("operators.deleteAuditToRelation"),
      isLoading: true,
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: {},
      headers: [
        {
          text: "Tabla",
          value: "tabla",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "dateStart",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "dateEnd",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      modoItem: "",
    };
  },
  computed: {
    filterTables() {
      const filter = this.getTablas?.filter(
        (table) =>
          !operators.state.edit?.audit?.some(
            (tableOld) => tableOld.tabla === table.tabla
          )
      );
      return filter;
    },
    getTablas() {
      return operators.state.tablas.data;
    },
    items() {
      if (
        !operators.state.edit.audit ||
        operators.state.edit.audit.length === 0
      ) {
        return [];
      }
      return operators.state.edit.audit.map((item) => {
        return item;
      });
    },
    modeTables: {
      get() {
        return operators.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    selectsData() {
      return [
        {
          name: "tabla",
          label: this.$tc("operators.tables"),
          data: "",
          items: this.filterTables,
          itemsValue: "tabla",
          itemsText: "tabla",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
    mode: {
      get() {
        return operators.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return operators.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    operators.dispatch("getOperators");
    this.isLoading = false;
  },
  methods: {
    async refreshItems() {
      await operators.dispatch("getOperatorId", operators.state.idOper);
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    disableSelectModo() {
      if (this.modoItem === "edit") {
        return true;
      } else {
        return false;
      }
    },
    save(items) {
      switch (this.typeForm) {
        case "add":
          this.addAuditItem(items);
          break;
        case "edit":
          this.editAuditItem(items);
          break;
        default:
          break;
      }
    },
    async addAuditItem(items) {
      let payload = {
        tablas: items.tabla.split(","),
      };
      payload.operId = operators.state.edit.operId;
      payload.fecDesde = date.state.dateFrom;
      if (!date.state.checkTo) {
        payload.fecHasta = date.state.dateTo;
      }
      await operators.commit("setNewAudit", payload);
      operators
        .dispatch("addAudit")
        .then(() => {
          this.isLoading = true;
          operators.dispatch("getOperatorId", payload.operId).then(() => {
            operators.commit("setOpenFormRelation", false);
            this.isLoading = false;
            this.showAlert(this.$tc("operators.addAuditSuccess"), "#82A1D0");
          });
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          date.state.checkTo = true;

          this.modoItem = "add";
          this.resetDate();
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.addAuditToRelation")
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "edit":
          this.modoItem = "edit";
          this.oldItems = item;
          this.itemId = item.id;
          await this.openEditForm(item);
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.editAuditToRelation")
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            operId: operators.state.edit.operId,
          };
          break;

        default:
          break;
      }
    },
    openEditForm(item) {
      this.selectsData[0].label = item.tabla;
      this.selectsData[0].data = item.tabla;
      date.state.dateFrom = moment(item.dateStart, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (item.dateEnd !== "") {
        date.state.dateTo = moment(item.dateEnd, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        date.state.checkTo = false;
      } else {
        date.state.checkTo = true;
      }
    },
    sendEdit(updatedItem) {
      operators.commit("setEditRelation", updatedItem);
      operators
        .dispatch("editAuditItem")
        .then(() => {
          operators.commit("setOpenFormRelation", false);
          this.showAlert(this.$tc("operators.editAuditSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#ff8d58");
        });
      this.reset(false);
    },
    editAuditItem() {
      let auditOld = this.oldItems;
      let changes = {};
      // fecha desde
      auditOld.dateStart = moment(auditOld.dateStart, "DD-MM-YYYY").format(
        "YYYY-MM-DD"
      );
      if (date.state.dateFrom !== auditOld.dateStart) {
        changes.fecDesdeNew = date.state.dateFrom;
      }
      // fecha hasta
      if (auditOld.dateEnd !== null) {
        auditOld.dateEnd = moment(auditOld.dateEnd, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );

        if (date.state.dateTo !== auditOld.dateEnd) {
          changes.fecHastaNew = date.state.dateTo;
        }
      }
      if (date.state.checkTo) {
        changes.haNoEx = true;
        delete changes.fecHastaNew;
      }
      if (Object.keys(changes).length > 0) {
        const updatedItem = { ...auditOld, ...changes };
        this.sendEdit(updatedItem);
      } else {
        operators.commit("setOpenFormRelation", false);
        this.showAlert(this.$tc("operators.editOperatorAlert"), "#f1c232");
      }
    },
    resetDate() {
      const today = moment().format("YYYY-MM-DD");
      date.commit("setDateFrom", today);
      date.commit("setDateTo", null);
    },
    reset() {
      this.resetDate();
      operators.commit("setModeFormRelation", "");
      operators.commit("setOpenFormRelation", false);
      this.selectsData[0].label = this.$tc("operators.tables");
      this.selectsData.forEach((item) => {
        item.data = "";
      });
    },
    cancel() {
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      operators
        .dispatch("deleteAudit")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(this.$tc("operators.deleteAuditSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },
    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};
      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();
      this.$emit("save", itemsComplete);
    },
  },
};
</script>
